import Vue from 'vue'
import Router from 'vue-router'
import index from '@/components/index'
import contact from '@/components/contact_us'
import info from '@/components/info'
import read from '@/components/read'
import search from '@/components/search'
import casepage from '@/components/case'
import customer from '@/components/customer'
import catalog from '@/components/catalog'
import wxbind from '@/components/wxbind'

Vue.use(Router)

export default new Router({
  mode:'history',
  routes: [
    {
      path: '/',
      name: 'index',
      component: index,
      meta: {
        title: '千年医典数据库',
        keepAlive: true,
        auth:false
      }
    },
    {
      path: '/contact_us',
      name: 'contact_us',
      component: contact,
      meta: {
        title: '千年医典数据库',
        keepAlive: true,
        auth:false
      }
    },
    {
      path: '/info/:book_id',
      name: 'info',
      component: info,
      meta: {
        title: '千年医典数据库',
        keepAlive: false,
        auth:false
      }
    },
    {
      path: '/read',
      name: 'read',
      component: read,
      meta: {
        title: '千年医典数据库',
        keepAlive: false,
        auth:true
      }
    },
    {
      path: '/search/:key',
      name: 'search',
      component: search,
      meta: {
        title: '千年医典数据库',
        keepAlive: false,
        auth:false
      }
    },
    {
      path: '/wxbind',
      name: 'wxbind',
      component: wxbind,
      meta: {
        title: '千年医典数据库',
        keepAlive: false,
        auth:true
      }
    },
    {
      path: '/case',
      name: 'case',
      component: casepage
    },
    {
      path: '/catalog',
      name: 'catalog',
      component: catalog
    },
    {
      path: '/customer',
      name: 'customer',
      component: customer
    },
    {
      path:'*',
      redirect:'/'
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js